module.exports = __webpack_public_path__ + "static/img/toilet.d470ee36.svg";